<template>
  <div>
    <div class="btn-wrapper d-flex justify-content-md-end justify-content-center">
      <button class="btn btn-outline-primary wizard-btn prev-btn" @click="previous">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button class="btn btn-primary wizard-btn next-btn" @click="nextStep" :disabled="false">
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="row mb-4 mt-3">
      <div class="col-md-6 mb-3">
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Informations de la demande</h5>
              <label>Project / Actions</label>
              <div class="row">
                <div class="col-12 jjj px-4">
                  <textarea class="form-control mt-4" v-model="description" cols="30" rows="7" placeholder="Description"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Montant de la demande</h5>
              <div class="row">
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="amount">Veuillez saisir un montant</label>
                  <d-input type="number" id="amount" v-model="amount" placeholder="€" onwheel="return false;"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Structure</h5>
              <fieldset class="mt-0 d-flex flex-wrap">
                <div v-for="structure in allStructures" class="col-6 div-no-padding">
                  <d-form-radio v-model="selectedStructure" :value="{ name: structure.name, id: structure.reference }"
                    class="mb-3">{{ structure.name }}</d-form-radio>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fr } from "vuejs-datepicker/dist/locale";
import $ from "jquery";
import validator from "validator";

export default {
  name: "StepTwo",
  props: ["user"],
  data() {
    return {
      description: "",
      amount: null,
      allStructures: [],
      selectedStructure: {},
      fr,
    };
  },

  mounted() {
    if(localStorage.getItem('model')) {
      let model = JSON.parse(localStorage.getItem('model'));
      this.description = model.description,
      this.selectedStructure = model.selectedStructure,
      this.amount = model.amount
    }
    this.$services.structure.findAll().then((response) => {
      this.allStructures = response.data;
    });
  },

  methods: {
    previous() {
      this.$emit("input", null);
    },

    nextStep() {
      if (
        !validator.isEmpty(this.description) &&
        this.amount != 0 &&
        this.selectedStructure.id
      ) {
        let model = {
          description: this.description,
          selectedStructure: this.selectedStructure,
          structureID: this.selectedStructure.id,
          structureName: this.selectedStructure.name,
          amount: this.amount,
          applicantFirstName: this.user.firstName,
          applicantLastName: this.user.lastName,
          creationDate: new Date(),
          applicantID: this.user.reference
        };
        this.$emit("input", model);
        localStorage.setItem('model', JSON.stringify(model));
      } else {
        this.$miniToastr.error("veuillez remplir tous les fichiers requis");
      }
    },
  },
};
</script>

<style scoped>
.card {
  position: relative;
  background-color: transparent;
}

.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}

.custom-card {
  background-color: #ffffff;
}

.custom-datepicker input {
  border: none !important;
  background-color: #b6bbdd !important;
  color: #007bff !important;
  border-radius: 15px !important;
  width: 50% !important;
  text-align: center !important;
  font-weight: 600 !important;
}

.document-container {
  background-color: #f6f8ff;
  border-radius: 15px;
}

.document-inside-container {
  background-color: #ffffff;
  margin: 10px 20px;
  color: #1f88ff;
  padding: 10px;
  border-radius: 10px;
  font-size: 10px;
}

.document-inside-button {
  background-color: #ffffff;
  margin: 10px 20px;
  padding: 10px;
  border-radius: 10px;
  color: #5a6169;
  font-weight: 500;
  display: flex;
  justify-content: center;
}

.document-inside-button:hover {
  cursor: pointer;
}

.document-add-button {
  border: 2px #4f78e2 dashed;
  border-radius: 15px;
  height: 100%;
  color: #4f78e2;
  padding: 10px;
}

.document-delete-button {
  position: absolute;
  top: 0;
  right: 0;
  color: #fc452d;
  background-color: #fddad5;
  border-radius: 5px;
  height: 25px;
  width: 25px;
}

.div-no-padding {
  padding: 0 !important;
}

.upload-file-text {
  margin-left: 7px;
  text-align: center;
  display: block;
}

.upload-file-icon {
  display: block;
}

.document-upload-progress-circle {
  text-align: center;
  color: #1f88ff;
}

.text-red {
  color: red;
  /* font-size: 16px; */
  font-weight: 900;
}

.emailExist {
  color: red;
  border: 1px solid red;
}

.emailExist:hover {
  border: 2px solid red;
}

.emailExistErrorText {
  color: red;
}

.emailExistErrorTextUnder {
  text-decoration: underline;
}

.emailExistErrorTextUnder:hover {
  cursor: pointer;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}
</style>
